import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeById } from '../lib/themes';

/**
 * Sidebar-bar quick toggle. Flips between the user's preferred dark/light theme.
 * If the user is on an experimental theme, the toggle still falls back to dark/light
 * for predictability; deeper theme selection lives in Profile → Appearance.
 */
const ThemeToggle = ({ className = '' }) => {
  const { theme, effectiveTheme, canToggle, setTheme } = useTheme();
  if (!canToggle) return null;

  // The toggle always swaps between the two everyday themes. Pickier choices
  // (NexFlow Blue, branded themes) live in the Profile → Appearance tab.
  const current = getThemeById(theme);
  const next = current.isDark ? 'light' : 'dark';
  const showLightIcon = getThemeById(effectiveTheme).isDark;

  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setTheme(next)}
      title={`Switch to ${next} mode`}
      className={`inline-flex items-center gap-1 px-2 py-1 rounded border border-[#262626] hover:border-[#D4AF37] text-xs transition-colors ${className}`}
    >
      {showLightIcon
        ? <Sun className="w-3.5 h-3.5 text-[#D4AF37]" />
        : <Moon className="w-3.5 h-3.5 text-[#D4AF37]" />}
      <span className="text-white">{showLightIcon ? 'Light' : 'Dark'}</span>
    </button>
  );
};

export default ThemeToggle;
